import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    clientSecret: String,
    publishableKey: String,
    returnUrl: String
  }

  static targets = ["submitButton", "buttonText", "spinner"]

  async connect() {
    // Load Stripe.js if not already loaded
    if (typeof Stripe === 'undefined') {
      await this.loadStripeJs()
    }

    this.stripe = Stripe(this.publishableKeyValue)

    // Create Elements with dark theme matching our UI
    const appearance = {
      theme: 'night',
      variables: {
        colorPrimary: '#a855f7',
        colorBackground: '#2d2d44',
        colorText: '#ffffff',
        colorDanger: '#ef4444',
        fontFamily: 'Inter, system-ui, sans-serif',
        borderRadius: '8px',
        spacingUnit: '4px',
        fontSizeBase: '14px'
      },
      rules: {
        '.Input': {
          backgroundColor: '#1e1e2f',
          border: '1px solid rgba(168, 85, 247, 0.2)',
          boxShadow: 'none'
        },
        '.Input:focus': {
          border: '1px solid #a855f7',
          boxShadow: '0 0 0 1px rgba(168, 85, 247, 0.3)'
        },
        '.Label': {
          color: '#a1a1aa'
        }
      }
    }

    this.elements = this.stripe.elements({
      clientSecret: this.clientSecretValue,
      appearance
    })

    const paymentElement = this.elements.create('payment', {
      layout: 'tabs'
    })

    paymentElement.mount('#payment-element')
    this.paymentElement = paymentElement
  }

  loadStripeJs() {
    return new Promise((resolve) => {
      const script = document.createElement('script')
      script.src = 'https://js.stripe.com/v3/'
      script.onload = resolve
      document.head.appendChild(script)
    })
  }

  async submit(event) {
    event.preventDefault()
    this.setLoading(true)
    this.hideError()

    try {
      const { error } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: this.returnUrlValue
        }
      })

      if (error) {
        this.showError(error.message)
        this.setLoading(false)
      }
      // If no error, the page will redirect to return_url
    } catch (e) {
      this.showError('An unexpected error occurred. Please try again.')
      this.setLoading(false)
    }
  }

  setLoading(loading) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = loading
    }
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = loading ? 'Processing...' : 'Subscribe - $9.99/month'
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.toggle('hidden', !loading)
    }
  }

  showError(message) {
    const errorDiv = document.getElementById('payment-errors')
    if (errorDiv) {
      errorDiv.textContent = message
      errorDiv.classList.remove('hidden')
    }
  }

  hideError() {
    const errorDiv = document.getElementById('payment-errors')
    if (errorDiv) {
      errorDiv.classList.add('hidden')
    }
  }
}
